import * as Yup from "yup";
import { toTitleCase } from "../Utils/helper";

export const LoginSchema = Yup.object().shape({
  userName: Yup.string()
    .min(2, "Username must be at least 2 characters")
    .max(25, "Username must not exceed 25 characters")
    .required("Username is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
});

export const CreateDepositTransactionSchema = Yup.object({
  transactionID: Yup.string().required("Transaction ID is required"),
  amount: Yup.number()
    .positive("Amount must be a positive number")
    .required("Amount is required"),
  paymentMethod: Yup.string()
    .oneOf(["UPI", "IMPS", "RTGS", "NEFT"], "Invalid Payment Method")
    .required("Payment Method is required"),
  userName: Yup.string().required("User Name is required"),
  bankName: Yup.string().required("Bank Name is required"),
  websiteName: Yup.string().required("Website Name is required"),
  transactionType: Yup.string()
    .oneOf(["Deposit", "Withdrawal"], "Invalid Transaction Type")
    .required("Transaction Type is required"),
  bonus: Yup.number().moreThan(-1, "Amount must be zero or  a positive number"),
  remarks: Yup.string().required("Remarks are required"),
});

export const CreateWithDrawTransactionSchema = Yup.object({
  transactionID: Yup.string().required("Transaction ID is required"),
  amount: Yup.number()
    .required("Amount is required")
    .positive("Amount must be a positive number"),
  paymentMethod: Yup.string()
    .oneOf(["UPI", "IMPS", "RTGS", "NEFT"], "Invalid Transaction Type")
    .required("Payment Method is required"),
  userName: Yup.string().required("User Name is required"),
  bankName: Yup.string().required("Bank Name is required"),
  websiteName: Yup.string().required("Website Name is required"),
  transactionType: Yup.string()
    .oneOf(["Deposit", "Withdraw"], "Invalid Transaction Type")
    .required("Transaction Type is required"),
  bankCharges: Yup.number().min(0, "bankCharges must be a positive number"),
  remarks: Yup.string().required("Remarks are required"),
});

export const CreateIntroducerSchema = Yup.object().shape({
  firstName: Yup.string()
    .min(2, toTitleCase("First name must be at least 2 characters"))
    .max(10, toTitleCase("First name must not exceed 10 characters"))
    .required(toTitleCase("First name is required")),

  userName: Yup.string()
    .min(2, toTitleCase("Username must be at least 2 characters"))
    .max(25, toTitleCase("Username must not exceed 25 characters"))
    .required(toTitleCase("Username is required")),

  lastName: Yup.string()
    .min(2, toTitleCase("Last name must be at least 2 characters"))
    .max(10, toTitleCase("Last name must not exceed 10 characters"))
    .required(toTitleCase("Last name is required")),

  password: Yup.string()
    .min(6, toTitleCase("Password must be at least 6 characters"))
    .required(toTitleCase("Password is required")),
});


export const CreateUserSchema = Yup.object({
  firstName: Yup.string()
    .min(2, toTitleCase("First name must be at least 2 characters"))
    .max(10, toTitleCase("First name must not exceed 10 characters"))
    // .matches(/^[A-Za-z]+$/, toTitleCase("First name must only contain alphabetic characters"))
    .required(toTitleCase("First name is required")),

  userName: Yup.string()
    .min(2, toTitleCase("Username must be at least 2 characters"))
    .max(25, toTitleCase("Username must not exceed 25 characters"))
    .required(toTitleCase("Username is required")),

  lastName: Yup.string()
    .min(2, toTitleCase("Last name must be at least 2 characters"))
    .max(10, toTitleCase("Last name must not exceed 10 characters"))
    // .matches(/^[A-Za-z]+$/, toTitleCase("Last name must only contain alphabetic characters"))
    .required(toTitleCase("Last name is required")),

  password: Yup.string()
    .min(6, toTitleCase("Password must be at least 6 characters"))
    .required(toTitleCase("Password is required")),

  contactNumber: Yup.string()
    .min(10, toTitleCase("Contact number must be at least 10 characters"))
    .max(10, toTitleCase("Contact number must be at most 10 characters"))
    .required(toTitleCase("Contact number is required")),

  introducersUserName1: Yup.string(),
  introducersUserName2: Yup.string(),
  introducersUserName3: Yup.string(),
  introducerPercentage1: Yup.number()
    .transform((value, originalValue) => {
      return originalValue === "" ? null : value;
    })
    .nullable()
    .notRequired()
    .min(1, toTitleCase("Minimum 1 %"))
    .max(10, toTitleCase("Maximum 10 %")),

  introducerPercentage2: Yup.number()
    .transform((value, originalValue) => {
      return originalValue === "" ? null : value;
    })
    .nullable()
    .notRequired()
    .min(1, toTitleCase("Minimum 1 %"))
    .max(10, toTitleCase("Maximum 10 %")),

  introducerPercentage3: Yup.number()
    .transform((value, originalValue) => {
      return originalValue === "" ? null : value;
    })
    .nullable()
    .notRequired()
    .min(1, toTitleCase("Minimum 1 %"))
    .max(10, toTitleCase("Maximum 10 %")),
  
  confirmPassword: Yup.string()
    .min(6, toTitleCase("Confirm password must be at least 6 characters"))
    .required(toTitleCase("Confirm password is required")),
});


export const CreateSubAdminSchema = Yup.object().shape({
  firstName: Yup.string()
    .required(toTitleCase("First name is required"))
    .min(2, toTitleCase("First name must be at least 2 characters"))
    .max(50, toTitleCase("First name must be at most 50 characters")),

  lastName: Yup.string()
    .required(toTitleCase("Last name is required"))
    .min(2, toTitleCase("Last name must be at least 2 characters"))
    .max(50, toTitleCase("Last name must be at most 50 characters")),

  userName: Yup.string()
    .required(toTitleCase("Username is required"))
    .min(3, toTitleCase("Username must be at least 3 characters"))
    .max(20, toTitleCase("Username must be at most 20 characters")),

  password: Yup.string()
    .required(toTitleCase("Password is required"))
    .min(6, toTitleCase("Password must be at least 6 characters"))
    .max(20, toTitleCase("Password must be at most 20 characters")),

  roles: Yup.array()
    .of(Yup.string().required(toTitleCase("Role is required")))
    .min(1, toTitleCase("Minimum one role is required")),
});

